/**
  * THIS IS A GENERATED FILE. DO NOT ALTER DIRECTLY.
  */

 ;
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgRadar = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" fillRule="evenodd" d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18m5.807-4.253a7.5 7.5 0 1 0-1.06 1.06l-1.424-1.424a5.5 5.5 0 1 1 1.06-1.06zm-3.469-1.348a4.125 4.125 0 1 1 1.06-1.06l-1.556-1.558a2 2 0 1 0-1.06 1.06z" clipRule="evenodd" /></svg>;
export default SvgRadar;